import React from 'react';
import PropTypes from 'prop-types';

const renderIcon = icon => {
  switch (icon) {
    case 'hamburger':
      return (
        <g fill="currentColor" fillRule="evenodd">
          <path d="M0 6h32v3H0zM0 15h32v3H0zM0 24h32v3H0z" />
        </g>
      );

    case 'info':
      return (
        <g transform="translate(9)" fill="currentColor" fillRule="nonzero">
          <path d="M13.898 28.513l-.445 1.824c-1.51.595-6.74 3.091-9.757.435-.899-.79-1.348-1.793-1.348-3.01 0-2.278.75-4.265 2.097-9.036.237-.9.528-2.071.528-3 0-1.6-.606-2.026-2.254-2.026-.805 0-1.695.287-2.5.588l.446-1.824c1.796-.73 4.052-1.62 5.985-1.62 2.9 0 5.03 1.445 5.03 4.195 0 .792-.137 2.18-.425 3.14l-1.667 5.897c-.343 1.192-.968 3.82-.003 4.599.953.77 3.203.362 4.313-.162z" />
          <circle cx="10.909" cy="3.636" r="3.636" />
        </g>
      );

    case 'close':
      return (
        <path
          d="M13.348 16L.532 3.184 3.184.532 16 13.348 28.816.532l2.652 2.652L18.652 16l12.816 12.816-2.652 2.652L16 18.652 3.184 31.468.532 28.816 13.348 16z"
          fill="currentColor"
          fillRule="evenodd"
        />
      );

    case 'check':
      return (
        <path
          d="M27.448 4.781L10.667 21.563l-6.115-6.115a2.667 2.667 0 0 0-3.77 3.77l8 8a2.667 2.667 0 0 0 3.77 0L31.219 8.553a2.667 2.667 0 0 0-3.771-3.77z"
          fill="currentColor"
          fillRule="nonzero"
        />
      );

    case 'search':
      return (
        <g transform="translate(2 2)" stroke="currentColor" strokeWidth="3.75" fill="none" fillRule="evenodd">
          <circle cx="11.25" cy="11.25" r="11.25" />
          <path d="M19.688 19.688l8.796 8.244" />
        </g>
      );

    case 'edit':
      return (
        <path
          d="M.023 31.299l1.469-4.897A5.815 5.815 0 0 1 2.95 23.96L21.617 5.29a.727.727 0 0 1 1.028 0l4.06 4.062a.727.727 0 0 1 0 1.028L8.038 29.049a5.82 5.82 0 0 1-2.443 1.46L.702 31.977a.546.546 0 0 1-.679-.678zM29.365.637l1.999 1.998c.848.849.848 2.224 0 3.073l-2.436 2.435a.724.724 0 0 1-1.025 0l-4.047-4.047a.725.725 0 0 1 0-1.024L26.292.636a2.172 2.172 0 0 1 3.073 0z"
          fill="currentColor"
          fillRule="nonzero"
        />
      );

    case 'delete':
      return (
        <path
          d="M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0zm7 20.2L20.2 23 16 18.8 11.8 23 9 20.2l4.2-4.2L9 11.8 11.8 9l4.2 4.2L20.2 9l2.8 2.8-4.2 4.2 4.2 4.2z"
          fill="currentColor"
          fillRule="nonzero"
        />
      );

    case 'email':
      return (
        <path
          d="M28.8 3H3.2A3.186 3.186 0 0 0 .016 6.2L0 25.4a3.2 3.2 0 0 0 3.2 3.2h25.6a3.2 3.2 0 0 0 3.2-3.2V6.2A3.2 3.2 0 0 0 28.8 3zm0 6.4l-12.8 8-12.8-8V6.2l12.8 8 12.8-8v3.2z"
          fill="currentColor"
          fillRule="nonzero"
        />
      );

    case 'phone':
      return (
        <path
          d="M30.57 24.61l-5.156-5.188a1.999 1.999 0 0 0-2.832-.004L18 24 8 14l4.588-4.588c.78-.78.782-2.046.002-2.828L7.43 1.416a2 2 0 0 0-2.83 0L.008 6.006 0 6c0 14.36 11.64 26 26 26l4.566-4.566c.78-.78.782-2.042.004-2.824z"
          fill="currentColor"
          fillRule="nonzero"
        />
      );

    case 'photo':
      return (
        <path
          d="M28 7h-4.434l-3-5h-9.132l-3 5H4a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h24a4 4 0 0 0 4-4V11a4 4 0 0 0-4-4zM16 26a7 7 0 1 1 0-14 7 7 0 0 1 0 14z"
          fill="currentColor"
          fillRule="nonzero"
        />
      );

    case 'flag':
      return (
        <path
          d="M29.284.254A.517.517 0 0 0 28.839 0H2.516A.516.516 0 0 0 2 .516v30.968a.516.516 0 0 0 1.032 0V19.613H28.84a.517.517 0 0 0 .45-.767l-5.021-9.04L29.29.767a.516.516 0 0 0-.006-.513z"
          fill="currentColor"
          fillRule="nonzero"
        />
      );

    case 'document':
      return (
        <g fill="currentColor" fillRule="nonzero">
          <path d="M17.94 5.848V.064H7.278A3.277 3.277 0 0 0 4 3.341v25.113a3.277 3.277 0 0 0 3.277 3.277h18.02a3.277 3.277 0 0 0 3.278-3.277V10.698H22.79a4.855 4.855 0 0 1-4.85-4.85zm5.491 20.038H8.243a1.233 1.233 0 0 1 0-2.467H23.43a1.233 1.233 0 0 1 0 2.467zm0-5.139H8.243a1.233 1.233 0 1 1 0-2.466H23.43a1.233 1.233 0 0 1 0 2.466zm1.233-6.493c0 .682-.552 1.234-1.232 1.234H8.243a1.233 1.233 0 0 1 0-2.467h15.189c.68 0 1.232.552 1.232 1.233z" />
          <path d="M22.79 9.125h5.785L19.514.065v5.783a3.277 3.277 0 0 0 3.276 3.277z" />
        </g>
      );

    case 'pin':
      return (
        <path
          d="M16.176 1C8.836 1 3 6.835 3 14.176c0 3.577 1.318 6.965 3.953 9.412.188.188 7.718 6.965 7.906 7.153.753.565 1.882.565 2.447 0 .188-.188 7.906-6.965 7.906-7.153 2.635-2.447 3.953-5.835 3.953-9.412C29.353 6.836 23.518 1 16.176 1zm0 16.941a3.776 3.776 0 0 1-3.764-3.765 3.776 3.776 0 0 1 3.764-3.764 3.776 3.776 0 0 1 3.765 3.764 3.776 3.776 0 0 1-3.765 3.765z"
          fill="currentColor"
          fillRule="nonzero"
        />
      );

    case 'book':
      return (
        <g fill="currentColor" fillRule="nonzero">
          <path d="M29.176.208H5.294C3.476.21 2.002 1.698 2 3.532v24.936c.002 1.835 1.476 3.322 3.294 3.324h23.882a.82.82 0 0 0 .583-.243.835.835 0 0 0 .241-.588V1.039a.835.835 0 0 0-.241-.588.82.82 0 0 0-.583-.243zM3.647 28.468V3.532A1.657 1.657 0 0 1 5.294 1.87h1.647v28.26H5.294a1.657 1.657 0 0 1-1.647-1.662zm24.706 1.662H8.588V1.87h19.765v28.26z" />
          <path d="M14.353 8.52h8.235a.827.827 0 0 0 .824-.832.827.827 0 0 0-.824-.83h-8.235a.827.827 0 0 0-.824.83c0 .46.37.831.824.831zM22.588 11.844h-8.235a.827.827 0 0 0-.824.831c0 .46.37.831.824.831h8.235a.827.827 0 0 0 .824-.83.827.827 0 0 0-.824-.832z" />
        </g>
      );

    case 'chat':
      return (
        <g fill="currentColor" fillRule="nonzero">
          <path d="M30.691 15.84A15.119 15.119 0 0 0 20.675 1.599 15.08 15.08 0 0 0 3.917 6.257 15.14 15.14 0 0 0 2.66 23.63L.537 30.012a.721.721 0 0 0 .909.91l6.371-2.126a15.075 15.075 0 0 0 15.21.203A15.124 15.124 0 0 0 30.69 15.84zM15.596 29.52a13.603 13.603 0 0 1-7.302-2.122.714.714 0 0 0-.613-.072l-5.326 1.779 1.776-5.335a.721.721 0 0 0-.072-.613A13.697 13.697 0 0 1 5.652 6.466a13.642 13.642 0 0 1 16.536-2.61 13.688 13.688 0 0 1 6.639 15.393A13.662 13.662 0 0 1 15.596 29.52z" />
          <path d="M21.346 18H8.407a.72.72 0 0 0 0 1.44h12.94a.72.72 0 0 0 0-1.44zM21.346 12.24H8.407a.72.72 0 0 0 0 1.44h12.94a.72.72 0 0 0 0-1.44z" />
        </g>
      );

    case 'group':
      return (
        <path
          d="M0 23.682c0-1.006.253-1.938.76-2.796a5.551 5.551 0 0 1 2.07-2.034 5.66 5.66 0 0 1 2.848-.747H6.68v1.312H5.678c-.79 0-1.517.192-2.18.575-.662.382-1.188.9-1.578 1.55a4.09 4.09 0 0 0-.584 2.14v5.225H0v-5.225zm3.006-9.004a3.353 3.353 0 0 1-1.219-1.19 3.126 3.126 0 0 1-.45-1.648c0-.59.15-1.137.45-1.64.3-.503.707-.903 1.22-1.197a3.287 3.287 0 0 1 1.67-.444c.6 0 1.157.148 1.669.444.512.294.919.694 1.219 1.197.3.503.45 1.05.45 1.64 0 .601-.15 1.15-.45 1.648-.3.498-.707.894-1.22 1.19a3.29 3.29 0 0 1-1.669.442 3.28 3.28 0 0 1-1.67-.442zm3.09-1.444c.389-.382.584-.847.584-1.394 0-.547-.195-1.011-.585-1.395a1.952 1.952 0 0 0-1.42-.574 1.96 1.96 0 0 0-1.41.574 1.868 1.868 0 0 0-.593 1.395c0 .547.195 1.011.584 1.394.39.383.863.574 1.42.574.557 0 1.03-.19 1.42-.574zm.855 10.448c0-1.006.254-1.938.76-2.796a5.549 5.549 0 0 1 2.071-2.034 5.66 5.66 0 0 1 2.847-.747h6.68a5.66 5.66 0 0 1 2.848.747 5.557 5.557 0 0 1 2.071 2.034c.506.858.76 1.79.76 2.796v5.225h-1.336v-5.225c0-.776-.195-1.49-.585-2.14a4.347 4.347 0 0 0-1.578-1.55 4.283 4.283 0 0 0-2.18-.574h-6.68c-.79 0-1.517.192-2.179.574-.663.383-1.188.9-1.578 1.55a4.09 4.09 0 0 0-.585 2.14v5.225H6.951v-5.225zm6.171-9.275a5.549 5.549 0 0 1-2.071-2.034 5.406 5.406 0 0 1-.76-2.796c0-1.006.253-1.938.76-2.797a5.549 5.549 0 0 1 2.071-2.034A5.658 5.658 0 0 1 15.969 4a5.66 5.66 0 0 1 2.848.746 5.554 5.554 0 0 1 2.07 2.034c.507.859.76 1.791.76 2.797a5.405 5.405 0 0 1-.76 2.796 5.554 5.554 0 0 1-2.07 2.034 5.656 5.656 0 0 1-2.848.746 5.651 5.651 0 0 1-2.847-.746zm5.027-1.14a4.34 4.34 0 0 0 1.578-1.55 4.09 4.09 0 0 0 .585-2.14 4.09 4.09 0 0 0-.585-2.14 4.342 4.342 0 0 0-1.578-1.55 4.28 4.28 0 0 0-2.18-.575c-.79 0-1.517.191-2.179.574-.662.383-1.188.9-1.578 1.55a4.087 4.087 0 0 0-.585 2.14c0 .777.195 1.49.585 2.14.39.652.916 1.168 1.578 1.551a4.278 4.278 0 0 0 2.18.574c.79 0 1.516-.191 2.179-.574zm7.444 1.41a3.359 3.359 0 0 1-1.219-1.189 3.126 3.126 0 0 1-.45-1.648c0-.59.15-1.137.45-1.64.3-.503.707-.903 1.22-1.197a3.288 3.288 0 0 1 1.67-.444c.6 0 1.157.148 1.669.444a3.34 3.34 0 0 1 1.22 1.197c.3.503.45 1.05.45 1.64 0 .601-.15 1.15-.45 1.648-.301.498-.708.894-1.22 1.19a3.29 3.29 0 0 1-1.67.442c-.6 0-1.158-.147-1.67-.442zm3.09-1.443a1.88 1.88 0 0 0 .584-1.394c0-.547-.195-1.011-.584-1.395a1.952 1.952 0 0 0-1.42-.574c-.546 0-1.016.192-1.41.574a1.868 1.868 0 0 0-.594 1.395c0 .547.195 1.011.585 1.394.39.383.863.574 1.42.574.556 0 1.029-.19 1.419-.574zm1.92 10.448a4.09 4.09 0 0 0-.584-2.14 4.343 4.343 0 0 0-1.579-1.55 4.284 4.284 0 0 0-2.179-.574H25.26v-1.312h1.002c1.025 0 1.974.249 2.847.746a5.557 5.557 0 0 1 2.071 2.034c.507.858.76 1.79.76 2.797v5.224h-1.336v-5.225z"
          fill="currentColor"
          fillRule="nonzero"
        />
      );

    case 'house':
      return (
        <g fill="currentColor" fillRule="nonzero">
          <path d="M15.833 28.127a.706.706 0 0 1-.478-.186l-.894-.822c-3.314-3.033-5.502-5.034-5.502-7.702 0-2.32 1.801-4.138 4.1-4.138 1.004 0 1.997.37 2.774 1.016a4.384 4.384 0 0 1 2.775-1.016c2.298 0 4.099 1.817 4.099 4.138 0 2.663-2.18 4.663-5.48 7.69l-.918.835a.705.705 0 0 1-.476.185zm-2.774-11.416c-1.502 0-2.68 1.188-2.68 2.706 0 2.033 2.003 3.865 5.033 6.637l.423.389.417-.38c3.04-2.788 5.035-4.617 5.035-6.646 0-1.518-1.177-2.706-2.68-2.706-.843 0-1.68.392-2.233 1.048-.27.32-.811.32-1.081 0a2.963 2.963 0 0 0-2.234-1.048z" />
          <path d="M26.622 32H5.042a.713.713 0 0 1-.71-.717V17.16H1.21a.71.71 0 0 1-.651-.432.72.72 0 0 1 .133-.774L15.315.217a.726.726 0 0 1 1.035 0l14.625 15.736a.721.721 0 0 1 .134.775.712.712 0 0 1-.652.432h-3.125v14.124a.713.713 0 0 1-.71.716zM5.753 30.566h20.16V16.443c0-.396.318-.717.71-.717h2.195L15.832 1.754 2.85 15.726h2.194c.392 0 .71.321.71.717v14.123z" />
        </g>
      );

    case 'notes':
      return (
        <g fill="currentColor" fillRule="nonzero">
          <path d="M5.156 5.336h16.263v1.422H5.156zM5.156 25.242h8.132v1.422H5.156z" />
          <path d="M25.134 29.556c0 .552-.45 1.001-1.002 1.001H2.443c-.551 0-1-.45-1-1.001V2.445c0-.552.449-1.001 1-1.001h21.69c.551 0 1 .449 1 1v4.667l1.423-1.422V2.445A2.426 2.426 0 0 0 24.132.02H2.443A2.426 2.426 0 0 0 .02 2.445v27.11a2.426 2.426 0 0 0 2.423 2.424h21.69a2.426 2.426 0 0 0 2.423-2.423V17.68l-1.422 1.422v10.453z" />
          <path d="M20.272 11.972H5.156v1.422H18.85zM14.389 18.606H5.156v1.422h8.67zM31.772 9.45l-2.98-2.981a.71.71 0 0 0-1.006 0L16.198 18.058c-.007.007-.126.16-.159.242l-1.946 4.926a.71.71 0 0 0 .922.923l4.927-1.946a1.29 1.29 0 0 0 .24-.16l11.59-11.588a.71.71 0 0 0 0-1.006zM16.018 22.222l.946-2.394 1.447 1.448-2.393.946zm3.662-1.688l-.987-.988-.987-.987L28.289 7.977l1.974 1.974L19.68 20.535z" />
        </g>
      );

    case 'time':
      return (
        <path
          d="M30.118 16A.941.941 0 0 1 32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0a.941.941 0 0 1 0 1.882C8.203 1.882 1.882 8.203 1.882 16c0 7.797 6.321 14.118 14.118 14.118 7.797 0 14.118-6.321 14.118-14.118zM16 16h7.53a.941.941 0 0 1 0 1.882h-8.471a.941.941 0 0 1-.941-.94V5.646a.941.941 0 0 1 1.882 0V16zm3.654-13.637A.941.941 0 1 1 20.14.545a.941.941 0 0 1-.487 1.818zm3.405 1.41A.941.941 0 1 1 24 2.144a.941.941 0 0 1-.941 1.63zm2.924 2.244a.941.941 0 1 1 1.33-1.33.941.941 0 0 1-1.33 1.33zm2.243 2.924A.941.941 0 1 1 29.856 8a.941.941 0 0 1-1.63.941zm1.41 3.405a.941.941 0 1 1 1.819-.487.941.941 0 0 1-1.818.487z"
          fill="currentColor"
          fillRule="nonzero"
        />
      );

    case 'more':
      return (
        <g transform="translate(0 13)" fill="currentColor" fillRule="evenodd">
          <circle cx="3.2" cy="3.2" r="3.2" />
          <circle cx="16" cy="3.2" r="3.2" />
          <circle cx="28.8" cy="3.2" r="3.2" />
        </g>
      );

    case 'arrowUp':
      return (
        <path
          d="M28 23.828l-12-12-12 12L1.172 21 14.586 7.586a2 2 0 0 1 2.828 0L30.828 21 28 23.828z"
          fill="currentColor"
          fillRule="nonzero"
        />
      );

    case 'arrowDown':
      return (
        <path
          d="M28 8.172l-12 12-12-12L1.172 11l13.414 13.414a2 2 0 0 0 2.828 0L30.828 11 28 8.172z"
          fill="currentColor"
          fillRule="nonzero"
        />
      );

    case 'facebook':
      return (
        <path
          d="M11.864 32l-.046-14.545H6v-5.819h5.818V8c0-5.398 3.343-8 8.159-8 2.307 0 4.29.172 4.867.249V5.89l-3.34.002c-2.619 0-3.126 1.244-3.126 3.07v2.674H26l-2.91 5.819h-4.712V32h-6.514z"
          fill="currentColor"
          fillRule="nonzero"
        />
      );

    case 'twitter':
      return (
        <path
          d="M32 6.09c-1.196.499-2.393.898-3.788.997 1.395-.797 2.392-2.093 2.89-3.589-1.295.798-2.69 1.296-4.186 1.595C25.72 3.798 24.025 3 22.23 3c-3.59 0-6.58 2.891-6.58 6.58 0 .498.1.996.2 1.495-5.483-.3-10.268-2.891-13.558-6.879a6.274 6.274 0 0 0-.897 3.29c0 2.293 1.196 4.287 2.89 5.483-1.096 0-2.093-.3-2.99-.798v.1c0 3.19 2.293 5.782 5.283 6.38-.598.1-1.096.2-1.694.2-.399 0-.798 0-1.197-.1.798 2.592 3.29 4.486 6.081 4.585-2.193 1.795-5.084 2.792-8.174 2.792-.498 0-1.097 0-1.595-.1 2.99 1.794 6.48 2.891 10.168 2.891 12.063 0 18.642-9.969 18.642-18.642V9.48c1.196-.997 2.293-2.094 3.19-3.39z"
          fill="currentColor"
        />
      );

    case 'linkedin':
      return (
        <path
          d="M30.7 0H1.3C.6 0 0 .6 0 1.3v29.3c0 .8.6 1.4 1.3 1.4h29.3c.7 0 1.3-.6 1.3-1.3V1.3C32 .6 31.4 0 30.7 0zM9.5 27.3H4.7V12h4.8v15.3zM7.1 9.9c-1.5 0-2.8-1.2-2.8-2.8 0-1.5 1.2-2.8 2.8-2.8 1.5 0 2.8 1.2 2.8 2.8 0 1.6-1.3 2.8-2.8 2.8zm20.2 17.4h-4.7v-7.4c0-1.8 0-4-2.5-4s-2.8 1.9-2.8 3.9v7.6h-4.7V12H17v2.1h.1c.6-1.2 2.2-2.5 4.5-2.5 4.8 0 5.7 3.2 5.7 7.3v8.4z"
          fill="currentColor"
          fillRule="nonzero"
        />
      );

    default:
      return false;
  }
};

const Icon = ({ className, icon }) => (
  <svg viewBox="0 0 32 32" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" className={className}>
    {renderIcon(icon)}
  </svg>
);

Icon.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string.isRequired,
};

Icon.defaultProps = {
  className: undefined,
};

export default Icon;
